import { render, staticRenderFns } from "./MatchBaselineStep.vue?vue&type=template&id=12dcc08b"
import script from "./MatchBaselineStep.vue?vue&type=script&lang=js"
export * from "./MatchBaselineStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports